import VehiclesError from './VehiclesError.js'

export default class GetBrandModelInfoVehiclesError extends VehiclesError {}
